export default "__VITE_ASSET__H7lH8r4W__"